module.exports = __webpack_public_path__ + "img/noStu.24459367.png";